var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeEdit1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.89,18.92c4.45-4.45,11.66-4.45,16.11,0,4.45,4.45,4.45,11.66,0,16.11l-27.04,27.04c-1.59,1.59-3.61,2.67-5.82,3.11l-11.17,2.24c-1.24.25-2.53-.14-3.43-1.04s-1.29-2.19-1.04-3.43l2.24-11.17c.44-2.21,1.52-4.23,3.11-5.82l27.04-27.04ZM75.63,24.29c-1.48-1.48-3.89-1.48-5.37,0l-1.44,1.44,5.37,5.37,1.44-1.44c1.48-1.48,1.48-3.89,0-5.37ZM68.82,36.47l-5.37-5.37-20.24,20.23c-.53.53-.89,1.21-1.04,1.94l-1.12,5.58,5.58-1.12c.73-.15,1.41-.51,1.94-1.04l20.23-20.24ZM27.06,19.54c-2.1,0-3.8,1.7-3.8,3.8v53.32c0,2.1,1.7,3.8,3.8,3.8h45.56c2.1,0,3.8-1.7,3.8-3.8v-26.58c0-2.1,1.7-3.8,3.79-3.8s3.8,1.7,3.8,3.8v26.58c0,6.29-5.1,11.39-11.39,11.39H27.06c-6.29,0-11.39-5.1-11.39-11.39V23.34c0-6.29,5.1-11.39,11.39-11.39h22.78c2.1,0,3.8,1.7,3.8,3.8s-1.7,3.79-3.8,3.79h-22.78Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeEdit1);
export default __webpack_public_path__ + "static/media/acae_edit_1.6d254eac.svg";
export { ForwardRef as ReactComponent };